import React from "react";
import { Link } from 'react-router-dom';
import Slider from "react-slick";


const settings = {
  centerMode: true,
  infinite: true,
  centerPadding: '100px',
  slidesToShow: 1,
  speed: 500,
  variableWidth: false,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        centerPadding: '80px',
      }
    },
    {
      breakpoint: 1024,
      settings: {
        centerPadding: '60px',
      }
    },
    {
      breakpoint: 480,
      settings: {
        centerPadding: '30px',
      }
    }
  ]
};
class HomeBannerSilder extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      updates: false
    }
  }


  settings = {
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1
  };

  render() {
    let topImages = this.props.topImages;
    
    return (
      <Slider {...this.settings}>
        {topImages.length && topImages.map(banner =>
          <div>
            <div className='banner-content-wrap' style={{ backgroundColor: banner.background_color }}>
              <div className='bannerImg' style={{ backgroundImage: `url(${banner.image})` }}>

                {banner.active_sale && (
                  <div className='saleBadge' style={{ backgroundColor: banner.background_color, color: banner.font_color }}>
                    <div>sale <span>now on!</span></div>
                  </div>
                )}
                <div className='bannerCaption'>
                  <Link to={banner.image_url}>
                    {banner.url_title}
                  </Link>
                </div>
              </div>
              <div className='banner-content' style={{ color: banner.font_color }}>
                <div className='subTitle'>{banner.sub_title}</div>
                <div className='title'>{banner.title}</div>
                <div className='details'>{banner.description}</div>
                <Link className='btn-border' to='/signup'>
                  Sign up
                </Link>
                <div className='rightVerticalText'>{banner.sideline}</div>
              </div>
            </div>
          </div>
        )}
      </Slider>
    )
  }
};

export default HomeBannerSilder;
